<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增产品
      </a-button>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.data.status===1?'禁用':'启用'"
            :alert-title="record.data.status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <product-modal
      ref="formRef"
      :product-visible="productVisible"
      :title="title"
      @onCancel="onCancel"
    >
      <form-button
        :btn-is-loading="btnIsLoading"
        @onCancel="onCancel"
        @onSubmit="onSubmit"
      />
    </product-modal>
  </div>
</template>
<script>
import { columns } from './data/index';
import { dealTable } from './utils/dealTable';
import ProductModal from './modal/index.vue';
export default {
  components: { ProductModal },
  data() {
    return {
      selectData: [],
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: true,
      productVisible: false,
      title: '',
      productId: undefined,
      btnIsLoading: false,
    };
  },
  mounted() {
    // 获取产品剂型
    this.getSystemConfig();
    // 获取表格数据
    this.getTableData({ page: this.current, pageSize: this.pageSize });
  },
  methods: {
    // 获取产品剂型
    async getSystemConfig() {
      let result = await this.$http.post('/system/getConfigs');
      if (result.data.status === 1) {
        this.productFormData = result.data.data.product_form;
      }
    },
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post('/product/getList', params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        if (this.productFormData) {
          data.forEach((item) => {
            let obj = {
              id: item.id,
              title: item.title,
              // product_form: dealTable(this.productFormData, item.product_form),
              qichacha_name: item.company.companyInfo.qichacha_name,
              data: item,
            };
            temp.push(obj);
          });
          this.data = temp;
        }
      }
    },
    // 编辑或新增
    editAndAdd(record) {
      this.productVisible = true;
      if (!record.id) {
        // 新增
        this.title = '新增产品';
        this.productId='';
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.resetFields();
        });
      } else {
        // 编辑
        this.productId = record.id;
        this.title = '编辑产品';
        this.$nextTick(() => {
          let data = {
            title: record.data.title,
            spec: record.data.spec,
            product_form: record.data.product_form,
            nmpn: record.data.nmpn,
            describe: record.data.describe,
			      department_id:record.data.department_id.split(',')
          };
          this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
        });
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            this.btnIsLoading=true;
			
			values.department_id=values.department_id.join(',')
            let result = await this.$http.post('/product/update', {
              ...values,
              id: this.productId ? this.productId : '',
            });
            this.btnIsLoading=false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.productVisible = false;
              this.getTableData({ page: this.current, pageSize: this.pageSize });
            }
          }
        },
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.productVisible = false;
    },
    // 禁用 启用
    async onConfirm(record) {
      console.log('TCL: onConfirm -> record', record);
      let result=await this.$http.post('/product/setStatus', {id: record.id, status: record.data.status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize });
      }
    },
    // 删除
    async onDelete(record) {
      let result = await this.$http.post('/product/setStatus', {
        id: record.id,
        status: -1,
      });
      if (result.data.status === 1) {
        this.$message.success(result.data.msg);
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
        });
      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({
        page: pagination.current,
        pageSize: pagination.pageSize,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
}
</style>
